import { SUPPORTED_LOCALES } from '@repo/config';
import { z } from 'zod';
import { vaultPostRequest } from '../helpers';

const requestSchema = z.object({
  locale: z.enum(SUPPORTED_LOCALES).optional(),
  limit: z.number().int().positive().optional(),
});

export type IWarmChallengesRequest = z.infer<typeof requestSchema>;

const responseSchema = z.object({
  accepted: z.boolean(),
  total: z.number(),
  enqueued: z.number(),
  duplicates: z.number(),
  byType: z.record(z.string(), z.number()),
});

export type IWarmChallengesResponse = z.infer<typeof responseSchema>;

export async function warmChallengesApi(
  body: IWarmChallengesRequest = {},
): Promise<IWarmChallengesResponse> {
  return vaultPostRequest({
    path: '/img/warm-challenges',
    body,
    schema: responseSchema,
  });
}
